import { useState, useEffect } from 'react';
import { useStore } from 'stores';
import { PlusCircle, Search } from 'assets/icons';
import { TABS } from 'constants/tabs';
import { formatStockName } from 'utils/stock';

export default function InputWithButton({ type, placeholder }) {
  const [showPopOut, setShowPopOut] = useState(false);
  const [searchString, setSearchString] = useState('');
  const BQMarketName = useStore((state) => state.BQMarketName); /** 所有股票代號 */
  const setCurrentStock = useStore((state) => state.setCurrentStock);
  const setCurrentTab = useStore((state) => state.setCurrentTab);

  useEffect(() => {
    if (searchString === '') {
      setShowPopOut(false);
    } else {
      setShowPopOut(true);
    }
  }, [searchString]);

  function handleChange(e) {
    setSearchString(e.target.value.trim());
  }

  async function handleItemClick(stock) {
    /** 個股資訊 */
    if (type === 'search') {
      setSearchString('');
      setCurrentStock(stock);
    }
    /** 自選策略 */
    if (type === 'plus') {
      /** 將選中的股票帶入個股資訊 */
      setCurrentTab(TABS.ALL_STOCK);
      setCurrentStock(stock);
    }
  }

  return (
    <div className="text-gray flex items-center mx-3 my-6 h-11 bg-gray-light relative">
      <div className="flex-1 border rounded-l-lg border-gray pl-3 h-full">
        <input
          type="text"
          placeholder={placeholder}
          className="border-0 outline-none bg-transparent h-full w-full"
          value={searchString}
          onChange={handleChange}
        />
      </div>
      <button className="bg-blue text-white flex items-center h-full px-3 rounded-r-lg">
        {type === 'search' && <Search />}
        {type === 'plus' && <PlusCircle />}
      </button>
      {showPopOut && (
        <div className="absolute top-12 bg-white rounded-lg shadow-lg w-full overflow-y-scroll max-h-80 z-10">
          {BQMarketName.filter(({ marketId, marketName }) => {
            return marketId.indexOf(searchString) >= 0 || marketName.indexOf(searchString) >= 0;
          }).map((item) => (
            <div
              key={`stock_${item.marketId}`}
              className="p-4"
              onClick={() => handleItemClick(item)}
            >
              {formatStockName(item)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
